// /canvas/$id — real route (design doc's G2). Mirrors apps/web's
// app/canvas/[id]/page.tsx: a pure `'use client'` page reading its own `id`
// via next/navigation's useParams() (shimmed onto TanStack params in
// next-compat/navigation.tsx), so it's lazy-imported directly per the
// porting convention (route-helpers.tsx) — same pattern as
// routes/admin-chat-detail.tsx. No server auth gate in the original; kept
// under `_authed` here, mirroring how routes/canvas.tsx (the /canvas index
// route) is already scoped. Registered into the route tree from
// routes/agents.tsx.
import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { authedRoute } from './guards';

const CanvasDetailPage = lazy(() => import('@/app/canvas/[id]/page'));

export const canvasDetailRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: '/canvas/$id',
  component: CanvasDetailPage,
});
